module.exports = __webpack_public_path__ + "static/media/light-cloud.7b9c7deb.svg";